<template>
  <ModuleSection>
    <Result :tipMessage="result.text" :status="result.status" />
    <div>
      <ul class="result-info-container">
        <li class="item">
          <label>{{ $t("网银流水号") }}</label>
          <span>{{ $route.query.orderFlowNo }}</span>
        </li>
        <li class="item">
          <label>{{ $t("指令状态") }}</label>
          <span>{{
            $t($_params.getDisplay("ORDER_STATUS", $route.query.orderState))
          }}</span>
        </li>
        <li class="item">
          <label>{{ $t("提交时间") }}</label>
          <span>{{ $_format.dataToDate($route.query.orderSubmitTime) }}</span>
        </li>
      </ul>
    </div>
    <div style="text-align: center; margin-top: 20px">
      <el-button @click="$router.go(-2)"> {{ $t("返回") }} </el-button>
    </div>

  </ModuleSection>
</template>

<script>
import Result from '@/components/common/Result'
import ModuleSection from '@/components/container/ModuleSection'
export default {
  components: {
    Result,
    ModuleSection
  },
  computed: {
    result () {
      const { orderState } = this.$route.query
      if (orderState === '99' || orderState === '98') {
        return {
          status: 'fail',
          text: '操作失败',
          color: '#27CBA4'
        }
      } else if (orderState === '90' || orderState === '11') {
        return {
          status: 'success',
          text: '操作成功',
          color: '#27CBA4'
        }
      } else {
        return {
          status: 'complete',
          text: '操作完成，请等待审核',
          color: '#FF8D4F'
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.result-info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width:300px;
  margin: 0 auto;
  .item {
    width:  100%;
    text-align: left;
    margin: 0 auto;
    margin-bottom: 30px;
    font-size: 14px;
    label {
      display: inline-block;
      width: 100px;
      color: #333752;
    }
    span {
      color: #5A607F;
    }
  }
}
</style>
